import React, { useState, useEffect } from "react";
import http from "./../../../../Services/http";
import { Link } from "react-router-dom";
import "./../Orders.css";

const Approved = ({ user }) => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      const { data } = await http.get("/orders/approved", {
        headers: {
          "x-token": localStorage.getItem("token"),
        },
      });

      setOrders(data.data);
    };

    fetchOrders();
  }, []);

  return (
    <div className="manage__orders">
      {!orders
        ? "Loading"
        : orders.map((order) => (
            <div key={order._id} className="manage__order">
              <div className="order__img--container">
                <img
                  className="order__img"
                  src={process.env.REACT_APP_IMAGES_URL + order.food.foodImage}
                  alt="food"
                />
              </div>

              <div className="order__text">
                <h4 className="order__food--title">{order.food.title}</h4>
                <p className="order__food--price">{order.food.price} $</p>
              </div>
              <div className="order__user">
                <h3 className="order__user--title">
                  Order By: {order.customer.name}
                </h3>
                <p className="order__user-number">
                  Phone Number: {order.phoneNumber}
                </p>
                <p className="order__user-address">Address: {order.adress}</p>
                <p className="order__user-address">
                  {order.adressOpt.length === 0
                    ? ""
                    : `Address: ${order.adressOpt}`}
                </p>
              </div>

              <Link
                to={`/dashborad/orders/approved/delete/${order._id}`}
                className="btn btn-login link block m-all"
              >
                Delete
              </Link>
            </div>
          ))}
    </div>
  );
};

export default Approved;
